export const isInternalLink = (url?: string) => {
  if (!url) {
    return false
  }

  if (url.startsWith('#') || url.startsWith('/')) {
    return true
  }

  try {
    const parsedUrl = new URL(url, window.location.origin)
    return parsedUrl.origin === window.location.origin
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return false
  }
}
